import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function Home() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="flex h-14 items-center justify-end px-6 lg:h-[60px] lg:px-8">
        <Button variant="outline" size="sm" asChild>
          {isAuthenticated ? (
            <Link to="/jams">Jams</Link>
          ) : (
            <Link to="/login">Log in</Link>
          )}
        </Button>
      </header>

      <main className="flex flex-1 items-center justify-center">
        <div className="text-center">
          <h1 className="text-5xl font-bold uppercase tracking-[0.2em] text-foreground mb-4">
            Cobar
          </h1>
          <p className="text-sm text-muted-foreground uppercase tracking-wider">
            Collaborative musical flowstate
          </p>
        </div>
      </main>
    </div>
  );
}
